module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1700.949a8807.svg";